import RepositoryFactory from '@/repositories/RepositoryFactory.js'

const AuthRepository = RepositoryFactory.get('auth')
const credentials = {
    accessTokenValidityPeriod:null,
    accessToken:null,
    accessTokenCreatedAt:null,
    accessTokenExpiresAt:null,

    refreshTokenValidityPeriod:null,
    refreshToken:null,
    refreshTokenCreatedAt:null,
    refreshTokenExpiresAt:null,
    
    username:null,
    password:null,
}

export default {
    async login(username,password,rememberMe){
        try {
            var response = await AuthRepository.login(username,password);
            this.setCredentials(response.data.access,response.data.refresh,true);
            if(rememberMe){
                this.rememberUser(username,password);
            }
            return true;
        } catch(error) {
            // this.clearCredentials();
            this.forgetUser();
            return error.response.data.detail;
        }
    },
    async refresh(){
        try {
            var response = await AuthRepository.refresh(credentials.refreshToken);
            var accessToken = response.data.access;
            this.setCredentials(accessToken,null);
        }
        catch (error) {
            this.clearCredentials();
            if(this.isRememberingUser()){
                this.loadCredentialsFromLocalStorage()
                var loginStatus = await this.login(credentials.username,credentials.password,false);
                if(loginStatus===true){
                    this.refresh();
                }
                else {
                    this.forgetUser();
                }
            }
            else {
                this.forgetUser();
            }
        }
    },
    async getToken(){
        if(credentials.accessToken===null && localStorage.getItem('accessToken')!==null)
            this.loadCredentialsFromLocalStorage();

        var currentTimestamp = this.currentTimestamp();
        if(currentTimestamp>=credentials.accessTokenExpiresAt)
            await this.refresh()
        return credentials.accessToken;
    },
    setCredentials(accessToken,refreshToken,setValidities){
        if(setValidities){
            // Böyle yapıldığında expire date'ler hesaplanırken validity period'lar da hesaplanır.
            credentials.accessTokenValidityPeriod=null;
            credentials.refreshTokenValidityPeriod=null;
        }
        if(accessToken !== undefined && accessToken !== null){
            var accessTokenDates = this.calculateExpireDate(accessToken, credentials.accessTokenValidityPeriod)
            credentials.accessTokenCreatedAt = accessTokenDates.createdAt;
            credentials.accessTokenExpiresAt = accessTokenDates.expiresAt;
            credentials.accessTokenValidityPeriod = accessTokenDates.tokenValidityPeriod;
            credentials.accessToken = accessToken;
        }

        if(refreshToken !== undefined && refreshToken !== null){
            var refreshTokenDates = this.calculateExpireDate(refreshToken,credentials.refreshTokenValidityPeriod);
            credentials.refreshTokenCreatedAt = refreshTokenDates.createdAt;
            credentials.refreshTokenExpiresAt = refreshTokenDates.expiresAt;
            credentials.refreshTokenValidityPeriod = refreshTokenDates.tokenValidityPeriod
            credentials.refreshToken = refreshToken;
        }

        this.setLocalStorage();
    },
    calculateExpireDate(token,tokenValidityPeriod){
        var tokenCreatedAt = this.currentTimestamp();

        if(tokenValidityPeriod===null){
            var payload=this.decodeJWT(token);
            tokenValidityPeriod = payload.exp - payload.iat;
        }

        var tokenExpiresAt = tokenCreatedAt + tokenValidityPeriod;
        return {createdAt:tokenCreatedAt,expiresAt:tokenExpiresAt,tokenValidityPeriod:tokenValidityPeriod}
        
    },
    setLocalStorage(){
        localStorage.setItem('accessToken',credentials.accessToken);
        localStorage.setItem('accessTokenCreatedAt',credentials.accessTokenCreatedAt);
        localStorage.setItem('accessTokenExpiresAt',credentials.accessTokenExpiresAt);
        localStorage.setItem('accessTokenValidityPeriod',credentials.accessTokenValidityPeriod)

        localStorage.setItem('refreshToken',credentials.refreshToken);
        localStorage.setItem('refreshTokenCreatedAt',credentials.refreshTokenCreatedAt);
        localStorage.setItem('refreshTokenExpiresAt',credentials.refreshTokenExpiresAt);
        localStorage.setItem('refreshTokenValidityPeriod',credentials.refreshTokenValidityPeriod)
        
    },
    loadCredentialsFromLocalStorage(){
        credentials.accessToken=localStorage.getItem('accessToken');
        credentials.accessTokenCreatedAt=parseInt(localStorage.getItem('accessTokenCreatedAt'));
        credentials.accessTokenExpiresAt=parseInt(localStorage.getItem('accessTokenExpiresAt'));
        credentials.accessTokenValidityPeriod=parseInt(localStorage.getItem('accessTokenValidityPeriod'));

        credentials.refreshToken=localStorage.getItem('refreshToken');
        credentials.refreshTokenCreatedAt=parseInt(localStorage.getItem('refreshTokenCreatedAt'));
        credentials.refreshTokenExpiresAt=parseInt(localStorage.getItem('refreshTokenExpiresAt'));
        credentials.refreshTokenValidityPeriod=parseInt(localStorage.getItem('refreshTokenValidityPeriod'));
        if(this.isRememberingUser()){
            credentials.username=localStorage.getItem('username')
            credentials.password=localStorage.getItem('password')
        }
    },
    rememberUser(username,password){
        credentials.username=username;
        credentials.password=password;

        localStorage.setItem('username',username);
        localStorage.setItem('password',password);
    },
    forgetUser(){
        credentials.username=null;
        credentials.password=null;

        localStorage.removeItem('username');
        localStorage.removeItem('password');
    },
    decodeJWT(token){
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    },
    isRememberingUser(){
        return localStorage.getItem('username')!==null && localStorage.getItem('password')!==null;
    },
    isLoggedIn(){
        return credentials.accessToken!==null || localStorage.getItem('accessToken')!==null;
    },
    clearCredentials(){
        credentials.accessToken=null;
        credentials.accessTokenCreatedAt=null;
        credentials.accessTokenExpiresAt=null;

        localStorage.removeItem('accessToken');
        localStorage.removeItem('accessTokenCreatedAt');
        localStorage.removeItem('accessTokenExpiresAt');
    },
    currentTimestamp(){
        return Math.floor(new Date().getTime()/1000);
    }
}